const CONSTANTS = {
  MOBILE_BREAKPOINT: 768,
  BRANDS: {
    PEUGEOT: 'Peugeot',
    CITROEN: 'Citroen',
    OPEL: 'Opel'
  },
  FINANCE_PRODUCTS: [
    { id: 'iown', title: 'iOWN <br/>Guaranteed Future Value ' }
    // { id: 'vl', title: 'Vehicle Loan' }
  ],
  FREQUENCY_OPTIONS: [
    { id: 'W', title: 'Weekly' }
    // { id: 'B', title: 'Fortnightly' },
    // { id: 'M', title: 'Monthly' }
  ],
  MILEAGE_OPTIONS: {
    PEUGEOT: [
      { id: '15000', label: '0 - 15,000', kms: 15000, value: 15000 },
      { id: '30000', label: '15,001 - 30,000', kms: 30000, value: 30000 }
    ],
    CITROEN: [
      { id: '15000', label: '0 - 15,000', kms: 15000, value: 15000 },
      { id: '30000', label: '15,001 - 30,000', kms: 30000, value: 30000 }
    ],
    OPEL: [
      { id: '7500', label: '0 - 7,500', kms: 7500, value: 7500 },
      { id: '15000', label: '7,501 - 15,000', kms: 15000, value: 15000 },
      { id: '30000', label: '15,001 - 30,000', kms: 30000, value: 30000 }
    ]
  },
  TERM_OPTIONS: {
    PEUGEOT: [
      { id: '4', label: '4 years', months: 48, value: 48, default: false },
      { id: '3', label: '3 years', months: 36, value: 36, default: true },
      { id: '2', label: '2 years', months: 24, value: 24, default: false },
      { id: '1', label: '1 year', months: 12, value: 12, default: false }
    ],
    CITROEN: [
      { id: '4', label: '4 years', months: 48, value: 48, default: false },
      { id: '3', label: '3 years', months: 36, value: 36, default: true },
      { id: '2', label: '2 years', months: 24, value: 24, default: false },
      { id: '1', label: '1 year', months: 12, value: 12, default: false }
    ],
    OPEL: [
      { id: '4', label: '4 years', months: 48, value: 48, default: true },
      { id: '3', label: '3 years', months: 36, value: 36, default: false },
      { id: '2', label: '2 years', months: 24, value: 24, default: false },
      { id: '1', label: '1 year', months: 12, value: 12, default: false }
    ]
  },
  INITIAL_INTEREST_RATE: {
    PEUGEOT: 10.95,
    CITROEN: 10.95,
    OPEL: 10.95
  },
  ESTABLISHMENT_FEES: 293.39,
  EST_FEE: 286,
  PPSR_FEE: 7.39,
  CURRENCY_FIELD_OPTIONS: {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    prefix: '$ ',
    numeralPositiveOnly: true,
    rawValueTrimPrefix: true
  },
  COUNTER_OPTIONS: {
    useGrouping: true,
    prefix: '$',
    decimalPlaces: 2
  },
  WHAT_IS_IOWN_LINK: {
    PEUGEOT: 'https://www.peugeot-newzealand.co.nz/iown/',
    CITROEN: 'https://www.citroen.co.nz/offers/iown/',
    OPEL: 'https://www.opel.co.nz/offers/new-car-offers/iown.html'
  },
  HOMEPAGE_LINK: {
    PEUGEOT: 'https://www.peugeot-newzealand.co.nz/iown/',
    CITROEN: 'https://www.citroen.co.nz/offers/iown/',
    OPEL: 'https://www.opel.co.nz'
  },
  KILOMETRES_TOOLTIP: {
    PEUGEOT: 'Our interest rates vary between 9.45% and 14.45% depending on your personal circumstances.',
    CITROEN: 'Our interest rates vary between 9.45% and 14.45% depending on your personal circumstances.',
    OPEL: 'Our interest rates vary between 9.45% and 14.45% depending on your personal circumstances.'
  },
  TEXTS: {
    CONTACT_PAGE_INTRO: `Whether you're looking for a car to complement your lifestyle,
      or need an entire fleet for your business,
      iOWN makes financing easy. Simply fill out the enquiry form below and we'll
      be in touch with you.`,
    CONTACT_PAGE_2: `After you submit your details, we'll be in touch shortly to
      check through your options.`
  }
}

export default CONSTANTS
